export default "__VITE_ASSET__CN2YHelJ__"